import { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { useLocation } from "react-router-dom";
import { RampUnit, TagBasedAdUnits, TaglessAdUnits } from "@outplayed/ramp";

const isProduction = process.env.NODE_ENV === "production";
const devMode = true && !isProduction;

type RampInContentContainerType = {
  className?: string;
  id?: string;
  type?: TagBasedAdUnits;
  header?: string;
};

export const RampInContentContainer = ({ className, id, type, header }: RampInContentContainerType) => {
  return (
    <div
      className={classNames(
        "flex flex-col bg-[#191937] flex-column gap-y-[6px] rounded-[3px]",
        {
          "px-[18px] pb-[18px] pt-[12px]": !!header,
          "p-[18px]": !header,
        },
        className,
      )}
    >
      {header && <div className="text-white text-[14px] h-[18px]">{header}</div>}
      <RampInContent id={id} type={type} />
    </div>
  );
};

function useSkinAdDetection() {
  const polling = useRef<NodeJS.Timer>();
  const [skinAdActive, setSkinAdActive] = useState(false);

  useEffect(() => {
    polling.current = setInterval(() => {
      const skinDiv = document.getElementById("siteSkinContainer");
      setSkinAdActive(!!skinDiv);
    }, 1000);

    return () => {
      polling.current && clearInterval(polling.current);
    };
  }, []);

  return skinAdActive;
}

interface RampInContentProps {
  className?: string;
  id?: string;
  type?: TagBasedAdUnits | TaglessAdUnits;
}

const RampInContent = ({ id = "ugg-in-content", type = TaglessAdUnits.InContent }: RampInContentProps) => {
  const location = useLocation();
  const skinAdActive = useSkinAdDetection();

  return (
    <div id={id} className={classNames("flex flex-col items-center")}>
      {!skinAdActive && (
        <RampUnit
          id="pw-in-content"
          type={type}
          className={classNames("h-[300px] w-full", {
            "bg-red-500 bg-opacity-50": devMode,
          })}
          pathname={location.pathname}
          search={location.search}
        />
      )}
    </div>
  );
};
